import { cols } from "@/config/system";
import { getStoreMapWithDicKey, mapValueFormat, momentFormat } from "@/utils/formatter";

export const tableColumn = [
  {
    type: "index",
    label: "序号",
    fixed: 'left',
    disabled: true,
    width: cols.number
  },
  {
    label: "运单号",
    prop: "billCode",
    slotName: 'billCode',
    width: cols.op3
  },
  {
    label: "电子面单账号",
    prop: "elecId",
    width: cols.op3
  },
  {
    label: "发件人姓名",
    prop: "sendName",
  },
  {
    label: "发件人手机号",
    prop: "sendMobile",
  },
  {
    label: "发件人地址",
    prop: "sendAddress",
    width: cols.auto,
    formatter: (row: any) => {
      return (row.sendPro || '') + (row.sendCity || '') + (row.sendDistrict || '') + (row.sendAddress || '');
    },
  },
  {
    label: "收件人姓名",
    prop: "receiveName",
  },
  {
    label: "收件人手机号",
    prop: "receiveMobile",
  },
  {
    label: "收件人地址",
    prop: "receiveAddress",
    width: cols.auto,
    formatter: (row: any) => {
      return (row.receivePro || '') + (row.receiveCity || '') + (row.receiveDistrict || '') + (row.receiveAddress || '');
    },
  },
  // {
  //   label: "备注",
  //   prop: "orderMark",
  // },
  {
    label: "订单创建时间",
    prop: "orderCreateDate",
    width: cols.op3,
    formatter: (row: any, column: any, cellValue: string) =>
      momentFormat(cellValue, "YYYY-MM-DD HH:mm:ss")
  },
  {
    label: "物流状态",
    prop: "billStatus",
    formatter: (row: any, column: any, cellValue: string) =>
      mapValueFormat(cellValue, getStoreMapWithDicKey('bill_list_status_type')),

  },
  {
    label: "最新状态时间",
    prop: "billStatusTime",
    width: cols.op3,
    formatter: (row: any, column: any, cellValue: string) =>
      momentFormat(cellValue, "YYYY-MM-DD HH:mm:ss")
  },
  {
    label: "操作",
    prop: "actions",
    fixed: 'right',
    width: cols.op3,
    slotName: 'actions'
  },
];
